interface IDriverNotificationMessages {
  message_sent: string;
  message_reviewed: string;
}

export const LIST_ITEMS_PER_PAGE: number = 50;

export const FXG_CONTRACTOR_TOOLTIP_CONTENT: string = $localize`As part of your FedEx Ground partnership, the ability to dismiss this event is disabled. To learn more please contact support at support@gomotive.com.`

export enum DRIVER_NOTIFICATION_STATUS {
  message_sent = 'message_sent',
  message_read = 'message_read',
  message_failed = 'message_failed',
  message_reviewed = 'message_reviewed',
}

export enum DRIVER_NOTIFICATION_MESSAGES_KEYS {
  message_sent = 'message_sent',
  message_reviewed = 'message_reviewed',
  message_failed = 'message_failed',
}

export const DRIVER_NOTIFICATION_MESSAGES: IDriverNotificationMessages = {
  message_sent: $localize`Sent to Driver`,
  message_reviewed: $localize`Reviewed by driver`,
};

export enum SEVERITY_FEEDBACK {
  yes = 'yes',
  less = 'less',
  more = 'more',
}

export enum CameraObstructionMap {
  road_facing_cam_obstruction = 'camera_obstruction',
  driver_facing_cam_obstruction = 'camera_obstruction',
}

export interface ICameraObstructionTypes {
  road_facing_cam_obstruction: string;
  driver_facing_cam_obstruction: string;
}

export type CameraObstructionDirectionType = keyof ICameraObstructionTypes;

export const CAMERA_OBSTRUCTION_TYPES: ICameraObstructionTypes = {
  road_facing_cam_obstruction: 'road_facing_cam_obstruction',
  driver_facing_cam_obstruction: 'driver_facing_cam_obstruction',
};

export const CAMERA_OBSTRUCTION_TYPE_LABELS: ICameraObstructionTypes = {
  road_facing_cam_obstruction: $localize`Road-facing`,
  driver_facing_cam_obstruction: $localize`Driver-facing`,
};
